export { default as Edit } from './edit'
export { default as Create } from './create'



// WEBPACK FOOTER //
// ./src/pages/widgets/reminder/index.js